// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18Cfc","title":"styles_title__1BrEA"};